/* eslint-disable */
import { getSecurityLockdown } from "./securityLockdown";

export async function assertSecurityLockdown(
  schoolId,
  capability = "action"
) {
  const lockdown = await getSecurityLockdown(schoolId);

  if (!lockdown?.enabled) return;

  const map = {
    invites: lockdown.freezeInvites,
    broadcasts: lockdown.freezeBroadcasts,
    exports: lockdown.freezeExports,
    sensitive: lockdown.freezeSensitiveActions,
  };

  if (map[capability]) {
    throw new Error(
      "This action is temporarily disabled due to Security Lockdown Mode."
    );
  }
}